import React from 'react';
import CelebrationHoorayBanner from 'fe-design-base/assets/illustrationsDeprecated/CelebrationHoorayBanner';
import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';

import HiringTeamSuccessBanner from '../HiringTeamSuccessBanner';

interface Props {
  firstName: string;
  lastName: string;
  showHiringBanner: boolean;
  onClose: () => void;
  onDiscoverNow: () => void;
  onDontShowAgain: () => void;
  isHiringBannerEnabled: boolean;
}

const SuccessView = ({
  firstName,
  lastName,
  showHiringBanner,
  onClose,
  onDiscoverNow,
  onDontShowAgain,
  isHiringBannerEnabled,
}: Props) => (
  <Box pt={142}>
    <Box ph={140}>
      <Box mb={20} hcenter>
        {!isHiringBannerEnabled ? (
          <Box pt={100}>
            <Icon iconName="Success" color="success300" w={48} h={48} />
          </Box>
        ) : (
          <CelebrationHoorayBanner w={180} h={180} />
        )}
      </Box>

      <Text
        variant="heading2"
        color="mono900"
        textAlign="center"
        i18n="add_team.individual_drawer.success"
        i18nProps={{
          name: `${firstName} ${lastName}`,
        }}
      />
    </Box>
    {showHiringBanner && (
      <HiringTeamSuccessBanner
        onClickClose={onClose}
        onClickDiscoverNow={onDiscoverNow}
        onClickDontShowAgain={onDontShowAgain}
      />
    )}
  </Box>
);

export default SuccessView;
